<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">ชื่อกลุ่ม:</label>
                  <input
                    id="caApproveGroup"
                    name="caApproveGroup"
                    v-model="caApproveGroup"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ชื่อกลุ่มอนุมัติ"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div id="AddAgent" class="col-xl-12 table-responsive">
                <label>ตัวแทนจำหน่าย (Agent)</label>
                <table
                  class="table table-sm table-striped table-bordered table-hover table-checkable"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 2%;">ลำดับ</th>
                      <th class="text-center" style="width: 15%;">ตัวแทนจำหน่าย</th>
                      <th class="text-center" style="width: 10%;">เครื่องมือ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="aItems == null || aItems.length == 0">
                      <td colspan="4" class="text-muted text-center">คลิก + เพื่อเพิ่มรายการใหม่</td>
                    </tr>
                    <template v-for="(item, i) in aItems">
                      <a-item-row
                        ref="aItems"
                        :key="i"
                        :rowIndex="i"
                        :item="item"
                        @removeItem="onRemoveAItemClick"
                      ></a-item-row>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4">
                        <button
                          type="button"
                          class="btn btn-sm btn-brand"
                          @click.prevent="onAddAItemClick"
                        >
                          <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="row">
              <div id="AddAgent" class="col-xl-12 table-responsive">
                <label>พนักงาน (BRT)</label>
                <table
                  class="table table-sm table-striped table-bordered table-hover table-checkable"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 2%;">ลำดับ</th>
                      <th class="text-center" style="width: 15%;">พนักงาน</th>
                      <th class="text-center" style="width: 10%;">เครื่องมือ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="brtItems == null || brtItems.length == 0">
                      <td colspan="4" class="text-muted text-center">คลิก + เพื่อเพิ่มรายการใหม่</td>
                    </tr>
                    <template v-for="(item, i) in brtItems">
                      <brt-item-row
                        ref="brtItems"
                        :key="i"
                        :rowIndex="i"
                        :item="item"
                        @removeItem="onRemoveBRTItemClick"
                      ></brt-item-row>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4">
                        <button
                          type="button"
                          class="btn btn-sm btn-brand"
                          @click.prevent="onAddBrtItemClick"
                        >
                          <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="row">
              <div id="AddAgent" class="col-xl-12 table-responsive">
                <label>ลำดับการอนุมัติ</label>
                <table
                  class="table table-sm table-striped table-bordered table-hover table-checkable"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 2%;">ลำดับ</th>
                      <th class="text-center" style="width: 15%;">พนักงาน</th>
                      <th class="text-center" style="width: 5%;">ลำดับอนุมัติ</th>
                      <th class="text-center" style="width: 10%;">สิทธิ์การแก้ไข</th>
                      <th class="text-center" style="width: 10%;">มีสิทธิ์การอนุมัติ</th>
                      <th class="text-center" style="width: 5%;">เครื่องมือ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="apItems == null || apItems.length == 0">
                      <td colspan="7" class="text-muted text-center">คลิก + เพื่อเพิ่มรายการใหม่</td>
                    </tr>
                    <template v-for="(item, i) in apItems">
                      <ap-item-row
                        ref="apItems"
                        :key="i"
                        :rowIndex="i"
                        :item="item"
                        @removeItem="onRemoveAPItemClick"
                      ></ap-item-row>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="7">
                        <button
                          type="button"
                          class="btn btn-sm btn-brand"
                          @click.prevent="onAddapItemClick"
                        >
                          <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>หมายเหตุ:</label>
                  <textarea placeholder="หมายเหตุ" class="form-control" v-model="caRemark" rows="5"></textarea>
                  <span class="form-text"></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="caInActiveStatus"
                        id="caInActiveStatus"
                        v-model="caInActiveStatus"
                      />
                      เปิดใช้งาน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary" data-dismiss="modal">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import select2 from "../../../Shared/Select2";
import aItemRow from "./AgentItemRow";
import brtItemRow from "./BRTItemRow";
import apItemRow from "./ApproverItemRow";

export default {
  components: {
    select2,
    aItemRow,
    brtItemRow,
    apItemRow
  },
  data: function() {
    var self = this;

    return {
      edit: false,
      aItems: [],
      aItemsTemp: [],
      brtItems: [],
      brtItemsTemp: [],
      apItems: [],
      apItemsTemp: [],
      caApproveGroup: null,
      caRemark: null,
      caInActiveStatus: true,
      i: 0
    };
  },
  methods: {
    onAddAItemClick(e) {
      this.aItems.push({
        aAgentRow: null,
        selectedAgentRow: null
      });
    },
    onAddBrtItemClick(e) {
      this.brtItems.push({
        brtEmployeeRow: null,
        selectedEmployeeRow: null
      });
    },
    onAddapItemClick(e) {
      this.apItems.push({
        apUserRow: null,
        apLevelRow: null,
        apEditRow: null,
        apApproveRow: null,
        selectedUserRow: null,
        selectedLevelRow: null,
        selectedEditRow: null,
        selectedApproveRow: null
      });
    },
    onRemoveAItemClick(index, delItem) {
      var self = this;
      self.aItemsTemp = self.aItems;
      self.aItems = [];
      self.aItemsTemp.splice(index, 1);
      setTimeout(function() {
        self.aItems = self.aItemsTemp;

        setTimeout(function() {
          for (let i = 0; i < self.aItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.aItems[i].$refs.aAgent.setSelectedData(
              self.aItems[i].selectedAgentRow
            );
          }
        }, 50);
      }, 50);
    },
    onRemoveBRTItemClick(index, delItem) {
      var self = this;
      self.brtItemsTemp = self.brtItems;
      self.brtItems = [];
      this.brtItemsTemp.splice(index, 1);
      setTimeout(function() {
        self.brtItems = self.brtItemsTemp;

        setTimeout(function() {
          for (let i = 0; i < self.brtItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.brtItems[i].$refs.brtEmployee.setSelectedData(
              self.brtItems[i].selectedEmployeeRow
            );
          }
        }, 50);
      }, 50);
    },
    onRemoveAPItemClick(index, delItem) {
      var self = this;
      self.apItemsTemp = self.apItems;
      self.apItems = [];
      this.apItemsTemp.splice(index, 1);
      setTimeout(function() {
        self.apItems = self.apItemsTemp;

        setTimeout(function() {
          for (let i = 0; i < self.apItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.apItems[i].$refs.apUser.setSelectedData(
              self.apItems[i].selectedUserRow
            );

            self.$refs.apItems[i].$refs.apLevel.setSelectedData(
              self.apItems[i].selectedLevelRow
            );

            self.$refs.apItems[i].$refs.apEdit.setSelectedData(
              self.apItems[i].selectedEditRow
            );

            self.$refs.apItems[i].$refs.apApprove.setSelectedData(
              self.apItems[i].selectedApproveRow
            );
          }
        }, 50);
      }, 50);
    },
    formSubmit: function(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }
      if (self.aItems.length + self.brtItems.length <= 0) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกพนักงานหรือตัวแทนจำหน่ายอย่างน้อย 1 คน",
          "error"
        );
        return false;
      }
      var listApItems = [];
      self.apItems.forEach(element => {
        listApItems.push(element.apLevelRow);
      });
      if (!listApItems.includes("APPROVE_LEVEL_1")) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกสายงานอนุมัติลำดับที่ 1",
          "error"
        );
        return false;
      } else if (
        !listApItems.includes("APPROVE_LEVEL_2") &&
        listApItems.includes("APPROVE_LEVEL_3")
      ) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกสายงานอนุมัติลำดับที่ 2",
          "error"
        );
        return false;
      }
      var caItems = [];
      var cbrtItems = [];
      var capItems = [];
      var orderAgent = 1;
      var orderEmp = 1;
      var orderApprove = 1;
      self.aItems.forEach(element => {
        caItems.push({
          AgentCode: element.aAgentRow,
          OrderId: orderAgent
        });
        orderAgent = orderAgent + 1;
      });
      self.brtItems.forEach(element => {
        cbrtItems.push({
          EmpID: element.brtEmployeeRow,
          OrderId: orderEmp
        });
        orderEmp = orderEmp + 1;
      });
      self.apItems.forEach(element => {
        capItems.push({
          UserId: element.apUserRow,
          Level: element.apLevelRow,
          IsEdit: element.apEditRow,
          Role: element.apApproveRow,
          OrderId: orderApprove
        });
        orderApprove = orderApprove + 1;
      });

      axios({
        method: "post",
        url: "/Api/Approver",
        data: {
          ApproveGroup: self.caApproveGroup,
          Remark: self.caRemark,
          Agents: caItems,
          Emps: cbrtItems,
          ApproverItems: capItems,
          InActiveStatus: !this.caInActiveStatus
        }
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    }
  },
  computed: {},
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>'
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>'
      };
    }

    // set validation rules
    $(self.$refs.form).validate({
      rules: {
        caApproveGroup: "required"
      },
      messages: {
        caApproveGroup: "กรุณากรอกชื่อกลุ่ม"
      }
    });
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Approver/CreateApprover.vue